import React from 'react';
import { useLanguage } from '../common/LanguageContext';
import '../../styles/typography.css';

function DesignerInfo() {
  const { translations } = useLanguage();

  return (
    <div className="space-y-6">
      {/*<h2 className="heading-secondary">{translations.designerPage.designerInfo.heading}</h2>*/}
      {translations.designerPage.designerInfo.paragraphs.map((text, index) => (
        <p className="normal-text" key={index}>
          {text}
        </p>
      ))}
    </div>
  );
}

export default DesignerInfo;
